import { useEffect, useState } from 'react';

export const useIntersectionObserver = (target: Element | null, options?: IntersectionObserverInit) => {
  const [entry, setEntry] = useState<IntersectionObserverEntry>();

  useEffect(() => {
    if (!target) {
      return;
    }

    const observer = new IntersectionObserver(([entry]: IntersectionObserverEntry[]) => setEntry(entry), options);
    observer.observe(target);

    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target]);

  return entry;
};
